export default class TicketRule {
    static isDevolution = (protocolCategory: string): boolean => {
        switch (protocolCategory) {
            case '1':
            case 'DEVOLUÇÃO':
            case '7':
            case 'RECLAMAÇÃO TÉCNICA':
            case '11':
            case 'OCORRÊNCIA TRANSPORTADORA':
                return true;
            default:
                return false;
        }
    };
}